import styled from 'styled-components'

interface FontSizeProps {
  fontSize?: number
}

export const Container = styled.div`
  padding-bottom: 24px;

  border-bottom: 1px solid;
  border-bottom-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#bababa')};

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`

export const Header = styled.div`
  display: flex;

  min-height: 66px;

  margin-bottom: 16px;

  .number {
    min-width: 55px;

    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-shrink: 0;

    padding: 0 12px;

    color: #f9f9f9;

    font-size: 18px;
    font-weight: 500;
    line-height: 23px;

    border-radius: 2px 0 0 2px;

    background-color: rgb(${({ theme }) => theme.blue.base});
  }

  .tooltip-wrapper {
    display: flex;
    flex-shrink: 0;
  }

  .code {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.2rem;
    text-align: start;

    height: 100%;

    flex-shrink: 0;

    padding: 0 12px;

    color: ${({ theme }) => (theme.isDark ? '#E3E3E3' : '#4A4A4A')};

    background: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#f9f9f9')};

    border-width: 1px 0px 1px 1px;
    border-style: solid;
    border-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#bababa')};
    border-radius: 0px;

    font-size: 10px;
    font-weight: 600;
    line-height: 14px;

    transition: all 0.2s ease;

    &:hover {
      color: rgb(${({ theme }) => theme.primary.base});
      filter: brightness(95%);

      text-decoration: underline;
    }
  }

  .hierarchy {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    flex-grow: 1;
    flex-wrap: wrap;
    gap: 6px;

    padding: 12px;

    border-width: 1px 0 1px 1px;
    border-style: solid;
    border-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#bababa')};

    font-size: 12px;
    font-weight: 500;
    line-height: 20px;

    border-radius: 0 2px 2px 0;

    overflow: hidden;

    text-align: start;
  }

  .arrow-button {
    border-width: 1px 1px 1px 0;
    border-style: solid;
    border-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#bababa')};
    border-radius: 0 2px 2px 0;

    background: none;

    padding: 10px;

    .icon {
      width: 20px;
      height: 20px;

      color: ${({ theme }) => (theme.isDark ? '#F3F3F3' : '#4B4B4B')};
    }
  }

  .eye-button {
    display: none;
  }

  @media only screen and (min-width: 800px) {
    .hierarchy {
      gap: 10px;

      flex-wrap: nowrap;

      border-width: 1px 0 1px 1px;
      border-radius: 0;

      .subject,
      .arrow {
        flex-shrink: 0;
      }

      .subject {
        max-width: 50%;

        white-space: normal;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .theme {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .arrow {
        display: block;
      }
    }

    .eye-button {
      display: block;
      flex-shrink: 0;

      width: 45px;

      border-width: 1px 1px 1px 0;
      border-style: solid;
      border-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#bababa')};
      border-radius: 0 2px 2px 0;

      background-color: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#F9F9F9')};

      .icon {
        color: rgb(${({ theme }) => theme.primary.base});
        width: 20px;
        height: 20px;
      }
    }

    .arrow-button {
      display: none;
    }
  }
`

export const DetailsDropdown = styled.div`
  margin-bottom: 24px;

  .open,
  .close {
    border: 0;
    background: none;

    color: rgb(${({ theme }) => theme.primary.base});

    text-align: start;

    font-size: 14px;
    font-weight: 600;
    line-height: 23px;
  }

  .dropdown {
    color: ${({ theme }) => (theme.isDark ? '#E3E3E3' : '#4A4A4A')};
    background-color: rgb(${({ theme }) => theme.background.low});

    border-top: 1px solid rgb(${({ theme }) => theme.grayscale[400]});

    display: flex;
    flex-direction: column;
    gap: 18px;

    font-size: 14px;
    font-weight: 400;
    line-height: 18px;

    overflow: hidden;

    padding: 16px 30px;

    &[data-hidden='true'] {
      padding: 0;
      height: 0;
    }

    .texts {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .group-1 {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .group-2 {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .close {
        text-align: start;
        margin-top: 18px;
      }
    }
  }

  .open {
    margin-top: 16px;
  }

  @media only screen and (min-width: 800px) {
    .dropdown {
      gap: 18px;

      .texts {
        &[data-flex='false'] {
          display: flex;
          flex-direction: row;
          justify-content: end;
          gap: 200px;
        }
        display: grid;
        grid-template-columns: 230px 250px;

        .group-1 {
          &[data-flex='false'] {
            display: flex;
            flex-direction: row;
            white-space: nowrap;
            gap: 200px;
          }
        }

        .group-2 {
          &[data-flex='false'] {
            display: flex;
            flex-direction: row;
            width: 100%;
          }
          display: grid;
          grid-template-columns: 350px 260px;
        }
      }
    }
  }
`

export const CanceledQUestion = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e74c3c;
  width: 110px;
  height: 35px;
  border-radius: 100px;
  margin: 10px 0px;

  h4 {
    color: #ffffff;
    font-weight: 600;
  }
`

export const Statement = styled.div<FontSizeProps>`
  margin-bottom: 26px;

  font-size: ${(props) => `${props.fontSize}px`} !important;

  p {
    line-height: 1.8rem;
    margin-bottom: 1.5em;
  }
  table {
    margin: 1rem auto;
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }
  td,
  th {
    border: 1px solid #aaa;
    text-align: left;
    padding: 8px;
  }
  tr:first-child {
    background-color: #ff5500;
    color: #fff;
  }
  tr:nth-child(even) {
    background-color: #dddddd;
  }

  .iframe-wrapper {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    border: 1px solid #ccc;
  }

  .video-component {
    width: 100%;
    height: auto;
  }
`

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .iframe-wrapper {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    border: 1px solid #ccc;
  }

  .video-component {
    width: 100%;
    height: auto;
  }
`

export const Option = styled.button<FontSizeProps>`
  background: none;
  border: none;

  display: flex;
  align-items: center;

  gap: 24px;

  padding: 16px;

  border: 2px solid;
  border-radius: 4px;
  border-color: ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#E3E3E3')};

  cursor: pointer;

  transition: all 0.3s ease;

  table {
    margin: 1rem auto;
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }
  td,
  th {
    border: 1px solid #aaa;
    text-align: left;
    padding: 8px;
  }
  tr:first-child {
    background-color: #ff5500;
    color: #fff;
  }
  tr:nth-child(even) {
    background-color: #dddddd;
  }

  .letter {
    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    text-align: center;

    width: 32px;
    height: 32px;

    font-size: 14px;
    font-weight: 700;
    line-height: 18px;

    border-radius: 100%;
    border: 2px solid;
    border-color: rgb(${({ theme }) => theme.blue.base});

    color: rgb(${({ theme }) => theme.blue.base});
  }

  .text {
    color: ${({ theme }) => (theme.isDark ? '#E3E3E3' : '#000000')};

    font-size: ${(props) => `${props.fontSize}px`} !important;
    font-weight: 500;
    line-height: 25px;

    text-align: start;
  }

  :hover:not(:disabled) {
    background-color: rgba(
      ${({ theme }) => theme.blue[600]},
      ${({ theme }) => (theme.isDark ? 0.3 : 0.1)}
    );

    border-color: rgb(${({ theme }) => theme.blue[600]});

    .letter {
      border-color: rgb(${({ theme }) => theme.blue[600]});
      color: rgb(${({ theme }) => theme.blue[600]});
    }
  }

  :disabled {
    cursor: not-allowed;
  }

  &[data-Canceled='true'] {
    border-color: #e3e3e3;
    cursor: not-allowed;
    opacity: 0.75;

    :hover {
      border-color: none;
    }

    .letter {
      border-color: #808080;
      cursor: not-allowed;
      opacity: 0.75;
      color: #808080;
    }

    .text {
      border-color: #e3e3e3;
      cursor: not-allowed;
      opacity: 0.75;
      color: #808080;
    }
  }

  :disabled:not([data-correct='true']):not([data-wrong='true']) {
    opacity: 0.75;
  }

  &&[data-selected='true'] {
    background-color: rgba(
      ${({ theme }) => theme.primary.base},
      ${({ theme }) => (theme.isDark ? 0.3 : 0.1)}
    );

    border-color: rgb(${({ theme }) => theme.primary.base});

    .letter {
      border-color: rgb(${({ theme }) => theme.primary.base});
      color: rgb(${({ theme }) => theme.primary.base});
    }
  }

  &&[data-wrong='true'] {
    background-color: rgba(
      ${({ theme }) => theme.red.base},
      ${({ theme }) => (theme.isDark ? 0.3 : 0.1)}
    );

    border-color: rgb(${({ theme }) => theme.red.base});

    .letter {
      border-color: rgb(${({ theme }) => theme.red.base});
      color: rgb(${({ theme }) => theme.red.base});
    }
  }

  &&[data-correct='true'] {
    background-color: rgba(
      ${({ theme }) => theme.greenSuccess[300]},
      ${({ theme }) => (theme.isDark ? 0.3 : 0.1)}
    );

    border-color: rgb(${({ theme }) => theme.greenSuccess[300]});

    .letter {
      border-color: rgb(${({ theme }) => theme.greenSuccess[300]});
      color: rgb(${({ theme }) => theme.greenSuccess[300]});
    }
  }
`

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 45px;

  margin-top: 30px;

  .group-1 {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  @media only screen and (min-width: 800px) {
    .group-1 {
      flex-direction: row-reverse;
      justify-content: flex-start;
      align-items: center;
      gap: 24px;
    }
  }

  @media only screen and (min-width: 1100px) {
    flex-direction: row-reverse;
    justify-content: space-between;
  }

  .group-2 {
    display: flex;
    align-items: center;
  }
`

export const Answer = styled.button`
  background: 0;
  border: 0;
  border-radius: 4px;

  color: rgb(${({ theme }) => theme.background.high});

  background-color: rgb(${({ theme }) => theme.primary.base});
  padding: 8px 21px;

  font-size: 16px;
  font-weight: 500;
  line-height: 22px;

  transition: opacity 0.3s ease;

  :disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const CommentsButton = styled.button`
  background: 0;
  border: 0;
  border-radius: 4px;

  color: rgb(${({ theme }) => theme.primary.base});

  display: flex;
  align-items: center;

  svg {
    margin-right: 8px;
    height: 18px;
    width: 18px;
  }

  font-size: 14px;
  font-weight: 700;
  line-height: 18px;

  transition: opacity 0.3s ease;

  :hover {
    text-decoration: underline;
  }

  :disabled {
    opacity: 0.6;
    cursor: not-allowed;
    text-decoration: none;
  }
`

export const CommentsContainer = styled.div<{ open: boolean }>`
  background: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#f9f9f9')};
  width: 100%;
  overflow: hidden;
  opacity: 0;
  height: 0;
  transition: all 0.3s ease;
  margin: 8px 0px;
  &.open {
    margin: 32px 0px;
    border: 1px solid ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#bababa')};
    opacity: 1;
    height: auto;
  }
`

export const CommentsHeader = styled.div`
  padding: 8px 14px;
  border-bottom: 1px solid ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#bababa')};
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    height: 30px;
    width: 30px;
    cursor: pointer;
  }

  > div {
    display: flex;
    gap: 8px;
    align-items: center;

    img {
      height: 52px;
      width: 52px;
      border-radius: 52px;
    }
  }

  @media only screen and (min-width: 800px) {
    padding: 16px 30px;
  }
`

export const CommentsText = styled.div<FontSizeProps>`
  padding: 8px 14px;

  @media only screen and (min-width: 800px) {
    padding: 16px 30px;
  }

  font-size: ${(props) => `${props.fontSize}px`} !important;

  p {
    line-height: 1.8rem;
    margin-bottom: 1.5em;
  }

  table {
    margin: 1rem auto;
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  td,
  th {
    border: 1px solid #aaa;
    text-align: left;
    padding: 8px;
  }
  tr:first-child {
    background-color: #ff5500;
    color: #fff;
  }
  tr:nth-child(even) {
    background-color: #dddddd;
  }

  .iframe-wrapper {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    border: 1px solid #ccc;
  }

  .video-component {
    width: 100%;
    height: auto;
  }

  img.custom-image {
    padding: 10px;
    max-width: 100%;
  }
`

export const Result = styled.div`
  display: flex;
  gap: 14px;
  flex-direction: column;
  align-items: flex-end;

  margin-top: 8px;

  .label {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }

  &[data-result='right'] {
    .label {
      color: rgb(${({ theme }) => theme.greenSuccess[300]});
    }
  }

  &[data-result='wrong'] {
    .label {
      color: rgb(${({ theme }) => theme.red.base});
    }
  }

  .correct {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 14px;

    color: rgb(${({ theme }) => theme.grayscale.neutral});

    font-size: 14px;
    font-weight: 700;
    line-height: 18px;

    .letter {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      width: 32px;
      height: 32px;

      border-radius: 2px;

      color: rgb(${({ theme }) => theme.greenSuccess[300]});

      background-color: rgba(
        ${({ theme }) => theme.greenSuccess[300]},
        ${({ theme }) => (theme.isDark ? 0.3 : 0.1)}
      );
    }
  }

  @media only screen and (min-width: 800px) {
    flex-direction: row;
    align-items: center;

    margin-top: 0;
  }
`

export const AssociatedTextContainer = styled.div`
  margin-bottom: 24px;
`

export const AssociatedTextHeader = styled.button`
  background: none;
  border: none;
  padding: 0;

  display: flex;
  align-items: center;
  gap: 8px;

  color: rgb(${({ theme }) => theme.primary.base});

  font-size: 16px;
  font-weight: 600;
  line-height: 23px;

  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`

export const AssociatedTextContent = styled.div<FontSizeProps>`
  margin-top: 16px;
  padding: 16px;

  background-color: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#f9f9f9')};
  border: 1px solid ${({ theme }) => (theme.isDark ? '#4A4A4A' : '#E3E3E3')};
  border-radius: 4px;

  font-size: ${(props) => `${props.fontSize}px`} !important;

  p {
    line-height: 1.8rem;
    margin-bottom: 1.5em;
  }

  table {
    margin: 1rem auto;
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid #aaa;
    text-align: left;
    padding: 8px;
  }

  tr:first-child {
    background-color: #ff5500;
    color: #fff;
  }

  tr:nth-child(even) {
    background-color: #dddddd;
  }

  .iframe-wrapper {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    border: 1px solid #ccc;
  }

  .video-component {
    width: 100%;
    height: auto;
  }

  @media only screen and (min-width: 800px) {
    padding: 24px 30px;
  }
`
